// components/Signup.jsx
import React, { useState, useEffect } from "react";
import "./css/login.css";
import { CiMail } from "react-icons/ci";
import { MdOutlinePassword } from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { url } from "../../Config";
import { useAuth } from "../../AuthContext";


const ALLOWED_PROFESSIONS = [
  "student",
  "teacher",
  "doctor",
  "researcher",
  "psychologist",
  "designer",
  "entrepreneur",
  "other"
];

const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/home";
  const { login, user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate(from, { replace: true });
    }
  }, [user, from, navigate]);

  const [form, setForm] = useState({
    username: "",
    email: "",
    dob: "",
    profession: "",
    password: "",
    confirmPassword: ""
  });

  const [otp, setOtp] = useState("");
  const [otpStage, setOtpStage] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

const handleSubmit = async () => {
  if (loading) return;

  setError("");

  if (!form.username || !form.email || !form.password || !form.dob || !form.profession) {
    setError("All fields are required.");
    return;
  }

  // Username validation
  // Only letters, numbers, underscores, must contain at least one letter, and at least 1 char
  const usernameRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9_]+$/;
  if (!usernameRegex.test(form.username)) {
    setError("Username can only contain letters, numbers, underscores, and must contain at least one letter.");
    return;
  }

  if (form.password.length < 8) {
    setError("Password must be at least 8 characters.");
    return;
  }

  if (form.password !== form.confirmPassword) {
    setError("Passwords do not match.");
    return;
  }

  try {
    setLoading(true);

    const response = await fetch(`${url}/api/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        username: form.username,
        email: form.email,
        password: form.password,
        dob: form.dob,
        profession: form.profession
      })
    });

    const data = await response.json();

    if (!response.ok) {
      setError(data.message || "Signup failed");
      setLoading(false);
      return;
    }

    // move to OTP step
    setOtpStage(true);
    setLoading(false);

  } catch (err) {
    setError("Network error. Please try again.");
    setLoading(false);
  }
};
  const verifyOtp = async () => {

    if (!otp) {
      setError("Enter OTP");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${url}/api/verify-signup-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: form.email,
          otp: otp
        })
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || "Invalid OTP");
        setLoading(false);
        return;
      }

      alert("Account created successfully!");
          // auto login
      await login(form.email, form.password);

     // navigate(from, { replace: true });

    } catch {
      setError("Verification failed");
      setLoading(false);
    }
  };

  const resendOtp = async () => {

    try {
      await fetch(`${url}/api/resend-signup-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: form.email
        })
      });

      alert("OTP resent to your email");

    } catch {
      setError("Failed to resend OTP");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">

        {!otpStage ? (
          <>
            <h2 className="login-title">Create Account</h2>
            <p className="login-subtitle">Join Pyschemetrics</p>

            {error && <div className="auth-error">{error}</div>}

            <div className="form-grid">

              <div className="input-group">
                <label>Username</label>
                <input
                  type="text"
                  name="username"
                  placeholder="Enter username"
                  value={form.username}
                  onChange={handleChange}
                />
              </div>

              <div className="input-group">
                <label><CiMail /> Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <div className="input-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="dob"
                  value={form.dob}
                  onChange={handleChange}
                />
              </div>

              <div className="input-group">
                <label>Profession</label>
                <select
                  name="profession"
                  value={form.profession}
                  onChange={handleChange}
                >
                  <option value="">Select Profession</option>
                  {ALLOWED_PROFESSIONS.map((p) => (
                    <option key={p} value={p}>
                      {p.charAt(0).toUpperCase() + p.slice(1)}
                    </option>
                  ))}
                </select>
              </div>

            </div>

            <div className="input-group">
              <label><MdOutlinePassword /> Password</label>
              <input
                type="password"
                name="password"
                placeholder="Minimum 8 characters"
                value={form.password}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Re-enter password"
                value={form.confirmPassword}
                onChange={handleChange}
              />
            </div>

            <button
              className={`login-btn ${loading ? "loading" : ""}`}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Sending OTP..." : "Sign Up"}
            </button>

            <p className="auth-toggle">
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </>
        ) : (
          <>
            <h2 className="login-title">Verify Email</h2>
            <p className="login-subtitle">Enter the OTP sent to your email</p>

            {error && <div className="auth-error">{error}</div>}

            <div className="input-group">
              <label>OTP</label>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e)=>setOtp(e.target.value)}
              />
            </div>

            <button
              className="login-btn"
              onClick={verifyOtp}
              disabled={loading}
            >
              Verify OTP
            </button>

            <p className="auth-toggle">
              Didn't receive OTP?{" "}
              <span
                style={{cursor:"pointer",color:"#4a90e2"}}
                onClick={resendOtp}
              >
                Resend OTP
              </span>
            </p>
          </>
        )}

      </div>
    </div>
  );
};

export default Signup;